import Swiper, { EffectFade, Pagination } from 'swiper';
import { domContentLoadEvent } from '../common/domContentLoadEvent';
import { closeModal, openModal } from './modal/simple-modal';

function initialize() {
    const dataModels = document.querySelector('.models360 .swiper-pagination').getAttribute('data-models');
    const models = dataModels.split(',');

    const swiper = new Swiper(document.querySelector('.swiper360'), {
        modules: [EffectFade, Pagination],
        slidesPerView: 1,
        loop: false,
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        pagination: {
            el: '.models360 .swiper-pagination',
            clickable: true,
            renderBullet: function (index, className) {
                return (
                    // '<button type="normal" class="flex min-w-[240px] flex-row items-center justify-between text-base font-black uppercase tracking-widest text-dark3a ' +
                    // className +
                    // '">' +
                    // '    <div class="h-[1px] w-[50px] bg-dark md:invisible"></div>' +
                    // '    <span>' +
                    // models[index] +
                    // '</span>' +
                    // '</button>'
                    '<button type="normal" class="w-full md:w-auto font-black text-base tracking-widest text-dark3a dark:text-white uppercase [&.swiper-pagination-bullet-active]:text-primary dark:[&.swiper-pagination-bullet-active]:text-white dark:[&.swiper-pagination-bullet-active]:underline ' +
                    className +
                    '">' +
                    models[index] +
                    '</button>'
                );
            },
        },
    });

    swiper.on('slideChange', function () {
        var elemento = document.getElementById('block360');
        elemento.scrollIntoView({
            behavior: 'smooth',
        });
    });

    /**
     * Modal 360
     */
    //Open Modal
    document.querySelectorAll('.models360 .btn-360').forEach(function (item, k) {
        item.addEventListener('click', function (event) {
            const url = event.currentTarget.getAttribute('data-href');

            const modal = document.querySelector('.modal-360');
            const iframe = modal.querySelector('iframe');

            iframe.classList.add('btn', 'loading');

            const script = document.createElement('script');
            script.src = url;
            modal.appendChild(script);

            iframe.addEventListener('load', function onLoad() {
                iframe.classList.remove('loading');
                iframe.removeEventListener('load', onLoad);
            });

            openModal('.modal-360');
        });
    });

    //Close Modal
    document.querySelector('.models360 .simple-modal .close-modal').addEventListener('click', function () {
        const modal = document.querySelector('.modal-360');
        const iframe = modal.querySelector('iframe');

        const script = modal.querySelector('script');
        if (script) {
            script.remove();
        }

        iframe.src = '';

        closeModal('.modal-360');
    });
}

domContentLoadEvent(initialize);
